import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EnvService } from 'src/app/env.service';
import { DashService } from '../../dash.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-days-summary',
  templateUrl: './custom-days-summary.component.html',
  styleUrls: ['./custom-days-summary.component.css']
})
export class CustomDaysSummaryComponent implements OnInit {

  //by default, start date is one day before current date
  startDate:Date=new Date(Date.now()-24*60*60*1000);
  //and end date is by default current date
  endDate:Date=new Date();

  //limit for maximum end date is current date
  maxEndDate:Date=new Date();

  constructor(private dialogRef: MatDialogRef<CustomDaysSummaryComponent>, public dashService: DashService, private http: HttpClient, private env: EnvService, private router: Router) {
    //prevents closing the current dialog when clicked outside
    dialogRef.disableClose=true;
  }
  ngOnInit(): void {
    
  }

}
